"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavWidget = void 0;
const react_1 = __importDefault(require("react"));
const NavWidget_styled_1 = require("./NavWidget.styled");
function NavWidget({ children }) {
    return (react_1.default.createElement(NavWidget_styled_1.Container, null, react_1.default.Children.map(children, (child, index) => {
        const key = child.props.title;
        if (index !== children.length - 1) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                child,
                react_1.default.createElement(NavWidget_styled_1.Divider, { flexItem: true, variant: "middle", orientation: "vertical", key: `${key}-divider` })));
        }
        return child;
    })));
}
exports.NavWidget = NavWidget;
